export default __webpack_public_path__ + "media/images/evaluations-jaune-c30cbae3b37ac2860963043a4354cc07.png";